import React, { ReactElement, useState } from "react";
import { ButtonColor, ButtonIconPosition, buttonIconPositionMap, buttonLabelSizeMap, ButtonSize, buttonSizeMap, ButtonVariant, buttonVariantKey, colorKey } from "./style";

interface Props {
    size: ButtonSize;
    label?: string;
    disabled?: boolean;
    icon?: ReactElement
    iconPosition: ButtonIconPosition
    variant: ButtonVariant
    color: ButtonColor
    onClick?: () => void
    fullWidth?: boolean
    iconSize?: number
}

export function ButtonComponent(props: Props) {
    const { label } = props
    const { color } = props
    const { variant } = props
    const { size } = props
    const { icon } = props
    const { onClick } = props
    const { disabled } = props
    const { iconPosition } = props
    const { fullWidth } = props
    const { iconSize } = props

    const [isDarker, setIsDarker] = useState(true);

    const handleMouseEnter = () => setIsDarker(false);
    const handleMouseLeave = () => setIsDarker(true);
    const handleFocus = () => setIsDarker(true);
    const handleBlur = () => setIsDarker(false);

    if ("paintWorklet" in CSS) {
        //@ts-ignore
        CSS.paintWorklet.addModule(
            "https://www.unpkg.com/css-houdini-squircle@0.3.0/squircle.min.js"
        );
    }

    return (
        <button
            onClick={(e) => {
                e.stopPropagation()
                onClick
                    && onClick()
            }}
            onMouseEnter={handleMouseEnter}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={disabled}            onMouseLeave={handleMouseLeave}

            style={{
                ...buttonSizeMap.get(size),
                ...colorKey(color, buttonVariantKey(variant, isDarker)).buttonVariant,
                ...buttonIconPositionMap.get(iconPosition),
                ...{ opacity: disabled ? 0.5 : 1, borderRadius: '8px', width: fullWidth ? '100%' : '', display: "flex", justifyContent: 'center', alignItems: 'center', gap: 8, borderWidth: '1px', borderStyle: 'solid', cursor: 'pointer', },
            }}
        >
            {iconPosition !== 'off' && icon && React.cloneElement(icon, { color: colorKey(props.color, buttonVariantKey(variant, isDarker)).buttonIconVariant, size: iconSize ?? 24 })}
            {
                props.label && props.iconPosition !== 'only' &&
                <span style={{ ...buttonLabelSizeMap.get(size), ...{ color: colorKey(color, buttonVariantKey(variant, isDarker)).buttonIconVariant } }}>{label}</span>
            }
        </button>

    )
}